import { UITheme } from './UITheme';
import * as Phaser from 'phaser';

export class FloatingText extends Phaser.GameObjects.Text {
    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0, '', {
            fontSize: '16px',
            color: '#ffffff',
            stroke: '#000000',
            strokeThickness: 2,
            fontFamily: UITheme.body
        });
        this.setOrigin(0.5);
    }

    public show(x: number, y: number, text: string, color: string = '#ffffff') {
        this.setPosition(x, y);
        this.setText(text);
        this.setColor(color);
        this.setAlpha(1);
        this.setActive(true);
        this.setVisible(true);

        this.scene.tweens.add({
            targets: this,
            y: y - 50,
            alpha: 0,
            duration: 800,
            ease: 'Power1',
            onComplete: () => {
                this.setActive(false);
                this.setVisible(false);
            }
        });

        // Pop-in effect
        this.setScale(0.5);
        this.scene.tweens.add({
            targets: this,
            scale: 1.2,
            duration: 150,
            yoyo: true,
            repeat: 0,
            ease: 'Back.out'
        });
    }
}
